<template>
  <Step
    :title="title"
    :subtitle="subtitle"
    :error-message="errorMessage"
    :validation-state="validationState"
    :is-loading="isLoading"
  >
    <Feedback :title="feedback" v-if="hasFeedback" />
    <slot />
    <template slot="loading">
      <Dot :is-loading="isLoading" />
      {{ loadingMessage }}
    </template>
    <template v-if="!hideButton" slot="actions">
      <Button
        :click="redirectToNbc(mainAction)"
        data-min-width="true"
        :error="isInvalid"
        v-html="computedButtonText"
        id="agentSubmit"
      />
      <Button
        v-if="secondaryButton"
        width="auto"
        color="white"
        :pseudolink="true"
        v-html="secondaryButtonHTML"
      />
    </template>
  </Step>
</template>

<script>
let stepToGo = "Welcome";
import router from "@/router";
import { Step, Button, Dot, Feedback } from "@dunia/ui";
import { VALID, INVALID, UNPROCESSED } from "@/lib/constants/validations.js";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import { GENERIC_LOADING_MESSAGE } from "@/forms/constants/onboarding-logic";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import FIELD_NAMES from "@/forms/constants/field-names";
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";

import { any } from "bluebird";
export default {
  name: "UiDuniaBaseStepLogin",

  components: {
    Step,
    Button,
    Dot,
    Feedback
  },

  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String
    },
    mainAction: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    loadingMessage: {
      type: String,
      default: GENERIC_LOADING_MESSAGE
    },
    isInvalid: {
      type: Boolean,
      required: true
    },
    isLastStep: {
      type: Boolean,
      required: true
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "Next"
    },
    secondaryButton: {
      type: String,
      default: null
    },
    secondaryAction: {
      type: Function,
      default: null
    },
    feedback: {
      type: String,
      default: ""
    },
    redirectFn: Function
  },
  computed: {
    computedButtonText() {
      if (this.isInvalid) {
        return "CHECK ERRORS";
      }
      return this.buttonText;
    },
    validationState() {
      if (this.isInvalid) {
        return INVALID;
      }
      if (this.isLoading) {
        return UNPROCESSED;
      }
      return VALID;
    },
    hasFeedback() {
      return this.feedback !== "";
    },
    secondaryButtonHTML() {
      return `<span>${this.secondaryButton}</span>`;
    }
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods: {
    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },
    actionHandler(callback) {
      return event => {
        event.preventDefault();
        //callback();
      };
    },
    redirectToNbc(callback) {
      return event => {
        event.preventDefault();
        var product = this.fieldValues(FIELD_NAMES.product);
        var formToGo = "";
         callback();
        if (product) {
          if (product.toLowerCase() === "personal loan".toLowerCase()) {
            formToGo = "Deem | Sales Loan";
           } //else if (product.toLowerCase() === "credit card") {
          //   formToGo = "Deem | Sales Credit Card";
          // }
           else if (product.toLowerCase() === "stp card" || product.toLowerCase() === "credit card") {
           formToGo = "Deem | STP Card";
          }
          else if (product.toLowerCase() === "stp loan" || product.toLowerCase() === "top up"  ) {
           formToGo = "Deem | STP Loan";
          }
          else if(product.toLowerCase() === "new car"|| product.toLowerCase() === "used car"){
            formToGo="Deem | NBC Auto Loan";
          }
           else if (product.toLowerCase() === "top up") {
           formToGo = "Deem | STP Top Up";
          }
        }
        callback();
        if (formToGo != "") {
          router.goToFormByName(formToGo, {
            stepNameToInit: stepToGo
          });
        }
      };
    }
  }
};
</script>

<style lang="scss"></style>
